"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ModalAccessibleLabel = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ModalAccessibleContext_1 = require("./ModalAccessibleContext");
var ModalAccessibleLabel_module_scss_1 = __importDefault(require("./ModalAccessibleLabel.module.scss"));
var ModalAccessibleLabel = function (_a) {
    var children = _a.children, _b = _a.isProminent, isProminent = _b === void 0 ? false : _b;
    return (react_1["default"].createElement(ModalAccessibleContext_1.ModalAccessibleContext.Consumer, null, function (_a) {
        var labelledByID = _a.labelledByID;
        return (react_1["default"].createElement("div", { id: labelledByID, tabIndex: -1, className: (0, classnames_1["default"])(ModalAccessibleLabel_module_scss_1["default"].modalLabel, isProminent && ModalAccessibleLabel_module_scss_1["default"].prominent) }, children));
    }));
};
exports.ModalAccessibleLabel = ModalAccessibleLabel;
exports.ModalAccessibleLabel.displayName = "ModalAccessibleLabel";
//# sourceMappingURL=ModalAccessibleLabel.js.map